<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M16 3A10.73 10.73 0 005.29 13.73c0 5 7.64 12.88 10 15.2a1 1 0 001.4 0c2.37-2.32 10-10.19 10-15.2A10.73 10.73 0 0016 3zm0 23.8c-5.31-5.34-8.71-10.41-8.71-13.07a8.71 8.71 0 1117.42 0c0 2.66-3.4 7.73-8.71 13.07z"/><path d="M21 9.93l-4.5-2.7a1 1 0 00-1 0L11 9.93a1 1 0 00-.49.85v5.44a1 1 0 00.49.85l4.5 2.7a.94.94 0 001 0l4.5-2.7a1 1 0 00.49-.85v-5.44a1 1 0 00-.49-.85zm-5-1.85l4 2.42-1.49.89-4-2.39zm-.5 10.54l-4-2.4v-4.84l4 2.39zM12 10.5l1.57-.94 4 2.41-1.57.95zm8.53 5.72l-4 2.4v-4.84l4-2.39z"/></svg>